import useCouriersHook from "./useCouriersHook";

const useCourierHook = (courierId: number) => {
  const couriers = useCouriersHook();
  return couriers?.find((c) => c.item_id === courierId);
};

export default useCourierHook;
